/**
 * Gestión → Inventario · **Entradas** (`/gestion/inventario/entradas`).
 *
 * Puerto de `Inventario::entrada` + `views/menu/inventario/entrada.php`: el
 * histórico de ingresos de stock (`entrada`/`detalle_entrada`) con su usuario, el
 * producto, la cantidad, la razón, el comprobante de la compra cuando lo hay y la
 * anulación del movimiento.
 */

import { ArrowLeft, ArrowDownToLine } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useDocumentTitle } from '@/hooks/use-document-title';

import { InventarioNav } from '../components/inventario-nav';
import { InventarioMovimientos } from '../components/inventario-movimientos';
import { useInventario } from '../inventario.api';

export function InventarioEntradasPage() {
  useDocumentTitle('Gestión · Inventario · Entradas');
  const inventario = useInventario();

  const productos = (inventario.data?.productos ?? []).map((producto) => ({
    id: producto.id,
    nombre: producto.nombre,
    unidad: producto.unidad,
  }));

  return (
    <div className="space-y-5">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <Link
            to="/inicio/gestion"
            className="inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-wider text-ink-400 transition-colors hover:text-brand-600"
          >
            <ArrowLeft className="size-3" aria-hidden="true" />
            Gestión
          </Link>
          <h1 className="mt-1 flex items-center gap-2 text-2xl font-bold tracking-tight text-ink-900">
            <ArrowDownToLine className="size-6 text-brand-500" aria-hidden="true" />
            Inventario · Entradas
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-ink-500">
            Ingresos de stock registrados, con la razón del ingreso y el comprobante de la compra
            cuando el producto venía de una compra pendiente de almacenar.
          </p>
        </div>

        <InventarioNav active="entradas" />
      </header>

      <InventarioMovimientos tipo="entrada" productos={productos} />
    </div>
  );
}
